<script setup>
import Docitem from '@/components/neta/Docitem.vue';
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-sheet
    min-height="1000px"
>
    <v-container fluid fill-height v-if="loading" style="height: 500px;">
      <v-layout justify-center align-center>
        <v-progress-circular :indeterminate="true" size="64" color="accent" />
      </v-layout>
    </v-container>
<div id="list">
    <v-list
        class="mt-1"
    >
        <v-list-item
            v-for="release in release_list"
            :key="release.doc_id"
        >
            <Docitem
                :release = release
                v-on:dialog_open="dialog_open($event)"
            >
            </Docitem>
        </v-list-item>
    </v-list>
    <div class="mask" v-if="pay_flg==false">
    </div>
</div>
</v-sheet>
</template>
<script>

export default{
    props : ["therm","kind","keyword","tag"],
    data () {
      return {
        release_list : null,
        loading      : true,
        pay_flg      : true,
        timeout      : 0,
      }
    },
    computed: {
        _allquery() {
              return [this.therm, this.kind,this.keyword,this.tag];
        }
    },
    watch : {
        _allquery() {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.getrel();
            }, 500);

        },
    },
    methods: {
        dialog_open : function(data){
            if(data.mode==3)
                this.$refs.repdialog.open(data.query,data.mode);
            else
                this.$refs.docdialog.open(data.query,data.mode);
        },
        getrel : async function(){
            var params = new URLSearchParams();
            params.append("keyword",this.keyword);
            params.append("tag",this.tag);
            if(this.therm != null && this.therm != "")
                params.append("category",this.therm);
            if(this.kind != null && this.kind != "")
                params.append("kind",this.kind);
            this.loading = true;
            this.release_list = [];
            await axios.post("/api/release/get_simdoc",params)
            .then(response => {
                this.release_list = response.data;
                this.loading = false;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        }
    },
    created : function(){
        if(this.release_list == null)
            this.getrel();
        //this.pay_flg = vmHeader.pay_flg;
    },
}
</script>
<style>
.mask{
    position : absolute;
    top  : 0 ;
    left : 0 ;
    width : 100%;
    height : 100%;
    background-color: white;
    opacity: 0.7;
}
.loading{
    display:flex;
    width:100%;
    height:100%;
    text-align:center;
}
</style>
